<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="在读状态" class="fn-left">
            <Select key="3" :selected.sync="listQuery.read_status" :data="readStatus" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="学员姓名" class="fn-left">
            <el-input v-model="listQuery.sub_name" />
          </el-form-item>
          <el-form-item label="家长手机号" class="fn-left">
            <el-input v-model="listQuery.phone" />
          </el-form-item>
          <el-form-item label="注册时间" class="fn-left">
            <el-date-picker v-model="listQuery.time" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime" />
          </el-form-item>
          <el-form-item label="适用年级" class="fn-left">
            <Select key="10" :selected.sync="listQuery.grade_id" :data="gradeLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="学员类型" class="fn-left">
            <Select key="5" :selected.sync="listQuery.kpi_status" :data="kpiStatusLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetStudentLists">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="ID" prop="sub_id" align="center" />
        <el-table-column label="注册时间" prop="create_time" align="center" />
        <el-table-column label="学员姓名" prop="sub_name" align="center" />
        <el-table-column label="年级" prop="grade_name" align="center" />
        <el-table-column label="家长手机号" prop="phone" align="center" />
        <el-table-column v-if="listQuery.read_status == '6'" label="学员类型" prop="kpi_status_name" align="center" />
        <el-table-column v-if="listQuery.read_status == '6'" label="语文剩余天数" prop="chinese_over_date" align="center" />
        <el-table-column v-if="listQuery.read_status == '6'" label="数学剩余天数" prop="math_over_date" align="center" />
        <el-table-column v-if="listQuery.read_status == '6'" label="英语剩余天数" prop="english_over_date" align="center" />
        <el-table-column align="center" label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="fnSetScore(scope.row.sub_id)">增减积分</el-button>
            <el-button type="primary" size="mini" @click="fnScoreDetail(scope.row.sub_id)">积分详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="listQuery.total" :page-size="listQuery.limit" @current-change="fnGetStudentLists" />
    </div>
    <el-dialog title="增减积分" :visible.sync="bShowAddScore">
      <el-form ref="postForm" :model="scorePostForm" :rules="scorePostRules">
        <el-form-item label="操作" prop="point">
          <el-radio-group v-model="scorePostForm.type">
            <el-radio label="inc">增加</el-radio>
            <el-radio label="dec">减少</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="积分变动" prop="point">
          <el-input-number v-model="scorePostForm.point" :min="1" :max="1000" label="描述文字" />
        </el-form-item>
        <el-form-item label="变动原因" prop="content">
          <el-input v-model="scorePostForm.content" type="textarea" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="fnSubmitScore()">确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>
<script>

import Select from '@/components/Select'
import commondata from '@/utils/commondata'
import { validateRequire } from '@/utils/validate'
// import Tool from '@/assets/js/tool.js'

export default {
  name: 'TiYouYouPackageList',
  components: {
    Select
  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      listQuery: {
        p: 1,
        limit: 20,
        subject_id: '',
        grade_id: '',
        sub_name: '',
        total: 0,
        read_status: '6',
        time: '',
        phone: '',
        begin_time: '',
        end_time: '',
        kpi_status: ''
      },
      scorePostForm: {
        sub_id: '',
        point: '',
        content: '',
        type: 'inc'
      },
      scorePostRules: {
        point: [{ validator: validateRequire, trigger: 'manual', message: '积分' }],
        content: [{ validator: validateRequire, trigger: 'manual', message: '变动原因' }]
      },
      bShowAddScore: false,
      packageTypes: commondata.TYY_PACKAGE_TYPE,
      packageStatus: commondata.OPEN_STATUS,
      gradeLists: commondata.GRADE_LISTS,
      kpiStatusLists: commondata.KPI_STATUS,
      readStatus: commondata.READ_STATUS,
      currentLoading: ''
    }
  },
  watch: {
    'listQuery.read_status': function() {
      this.fnGetStudentLists()
    }
  },
  created() {
    this.fnGetStudentLists()
  },
  methods: {
    fnGetStudentLists: function() {
      this.bCreatePackage = false
      this.$http.tyyGetTyyStudentsList(this.listQuery).then(res => {
        this.listQuery.total = parseInt(res.data.count)
        this.lists = res.data.list
      })
    },
    changeTime: function(val) {
      if (val != null) {
        this.listQuery.begin_time = val[0]
        this.listQuery.end_time = val[1]
      } else {
        this.listQuery.begin_time = ''
        this.listQuery.end_time = ''
        this.listQuery.time = []
      }
    },
    fnSetScore: function(sub_id) {
      this.scorePostForm.sub_id = sub_id
      this.bShowAddScore = true
    },
    fnScoreDetail: function(sub_id) {
      this.$router.push({
        path: 'tyyScoreList',
        query: { sub_id: sub_id }
      })
    },
    fnSubmitScore: function() {
      this.$refs.postForm.validate(valid => {
        if (valid) {
          this.$http.tyyEditPoint(this.scorePostForm).then(res => {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
            this.bShowAddScore = false
            this.scorePostForm.content = ''
            this.scorePostForm.point = 1
            this.scorePostForm.type = 'inc'
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
  .food-search {
    ::v-deep .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
      padding-left: 70px !important;
    }
    ::v-deep .el-tabs--top .el-tabs__item.is-top:last-child {
      padding-right: 20px !important;
    }
  }
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }

</style>
